// extracted by mini-css-extract-plugin
module.exports = {"new":"view-default_new_3KmV4","dangerous":"view-default_dangerous_y3Tkm"};